import { StyledLabel, StyledSubLabel } from "./styles";

interface LabelProps {
	text?: string | number | null;
	subText?: string;
	titleCassName?: string;
	subtitleClassName?: string;
	className?: string;
	isTitle?: boolean;
	required?: boolean;
}

const Label = ({
	text,
	subText,
	titleCassName = "",
	subtitleClassName = "mt-3",
	isTitle,
	className = "",
	required,
}: LabelProps) => {
	return (
		<div className={className}>
			{isTitle ? (
				<h5 className={"fw-bolder mb-0 " + titleCassName}>{text + (required ? "*" : "")}</h5>
			) : (
				<StyledLabel className={"fw-bold text-dark label " + subtitleClassName} $subText="2em">
					{text + (required ? "*" : "")}
				</StyledLabel>
			)}
			{subText && <StyledSubLabel className="text-dark-emphasis">{subText}</StyledSubLabel>}
		</div>
	);
};

export default Label;
